import {
    Unstable_Grid2 as Grid,  Box, 
    Stepper, Step, StepLabel
} from '@mui/material';
import {  OutputTableInfo } from '../../../data/interfaces/sharedmodels';
import { useAppDispatch, useAppSelector } from '../../../stores/hooks';
import OutputTables from '../../../shared/tablegencomponenents/outputtables';
import { useEffect, useState } from 'react';
import magneticService from '../../../data/api/magnetic.service';
import NLCList from '../../../shared/nlclist';
import BuildSettings from '../../../shared/tablegencomponenents/buildsettings';
import BuildSummary from '../../../shared/tablegencomponenents/buildsummary';
import OutputTableDetails from '../../../shared/tablegencomponenents/outputtabledetails';


export default function MagneticOutputTables() {
    const selectedTable = useAppSelector((state) => state.magneticReducer.selectedOutputTable);
    const [tables, setTables] = useState<OutputTableInfo[]>([]);
    const [widthArray, setWidthArray] = useState([3, 3, 6]);
    const tableexpanded = useAppSelector((state) => state.magneticReducer.outputtableExpanded);
    const activeStep = useAppSelector((state) => state.magneticReducer.buildTableStep);
    useEffect(() => {
        magneticService.getoutputTables().then((response) => {
            setTables(response.data);
        })
    }, []);



    useEffect(() => {
        if (tableexpanded) {
            setWidthArray([0, 0, 12]);

        }
        else {
            setWidthArray([3, 3, 6]);
        }
    }, [tableexpanded]);
    return (
        <Box>
            <Stepper activeStep={activeStep} sx={{p:1,pb:2}}>
                <Step>
                    <StepLabel>Select Tables & Stations</StepLabel>
                </Step>
                <Step>
                    <StepLabel>Confim Settings</StepLabel>
                </Step>
                <Step>
                    <StepLabel>Summary</StepLabel>
                </Step>
                
            </Stepper>
            {activeStep==0?
                <Grid container spacing={tableexpanded ? 0 : 1}>
                    <Grid xs={widthArray[0]}>
                        <OutputTables parent='magnetic' tables={tables} />
                    </Grid>
                    <Grid xs={widthArray[1]}>
                        <NLCList parent='magnetic_output' disabled={selectedTable == null ? false : selectedTable.IsGlobal} />
                    </Grid>
                    <Grid xs={widthArray[2]}>
                        <OutputTableDetails table={selectedTable} parent='magnetic'/>
                        {/* <OutputDataList parent='magnetic' heading={selectedTable?.Description} tables={data} /> */}
                    </Grid>
                </Grid>
                :activeStep==1?
                <BuildSettings parent='magnetic'></BuildSettings>
                :<BuildSummary parent='magnetic'/>}
        </Box>
    );
}